import type {BroadcastEvents} from '@lib/rootScope';
import {LangPackDifference} from '@layer';
import {CommonDatabase, getCommonDatabaseState} from '@config/databases/state';
import {MOUNT_CLASS_TO} from '@config/debug';
import {StateSettings} from '@config/state';

import AppStorage from '@lib/storage';
import {ActiveAccountNumber} from '@lib/accounts/types';
import DeferredIsUsingPasscode from '@lib/passcode/deferredIsUsingPasscode';

export type PasscodeStorageValue = {
  /**
   * Have different random hash salt per user to prevent precomputed attacks
   *
   * Used to randomize the verification hash
   */
  verificationSalt: Uint8Array;
  /**
   * Hash used just to verify whether the passcode is correct, the hash for encryption will not be stored anywhere except in memory
   */
  verificationHash: Uint8Array;
  /**
   * Salt used for getting a cryptographic key derived from passcode that will be used for encryption (instead of passing raw passcode between processes)
   *
   * Used to randomize the encryption per user
   */
  encryptionSalt: Uint8Array;
};

type AppStorageValue = {
  langPack: LangPackDifference;
  settings: StateSettings;
  /**
   * Keys of the notifications that haven't been read yet, per account. Shared by every tab, so the
   * badge survives a reload and can be cancelled by whichever tab learns about the read first
   */
  pendingNotifications: Partial<Record<ActiveAccountNumber, BroadcastEvents['notification_cancel'][]>>;
  passcode: PasscodeStorageValue;
};

class CommonStateStorage extends AppStorage<AppStorageValue, CommonDatabase> {
  constructor() {
    super(getCommonDatabaseState(), 'session');
  }
}

const commonStateStorage = new CommonStateStorage();

commonStateStorage.get('settings', false).then((settings) => {
  DeferredIsUsingPasscode.resolveDeferred(settings?.passcode?.enabled || false);
});

MOUNT_CLASS_TO.commonStateStorage = commonStateStorage;
export default commonStateStorage;
